import { useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useStores } from "../../store";
import { Divider, Modal, Spin } from "antd";
import { __ } from "../../utils";
import { PluginUpdateForm, PluginUpdateLicenseList, PluginUpdateErrorNotice } from ".";
const PluginUpdateModal = observer(() => {
  const [doReloadAfterClose, setDoReloadAfterClose] = useState(false);
  const {
    pluginUpdateStore
  } = useStores();
  const {
    busy,
    modalPlugin,
    pluginUpdates,
    pluginUpdateFetchErrors
  } = pluginUpdateStore;
  const pluginUpdate = modalPlugin ? pluginUpdates.get(modalPlugin) : undefined;
  const showHeadline = (pluginUpdate === null || pluginUpdate === void 0 ? void 0 : pluginUpdate.unlicensedEntries.length) > 0 && (pluginUpdate === null || pluginUpdate === void 0 ? void 0 : pluginUpdate.licensedEntries.length) > 0;
  const handleCancel = useCallback(() => {
    if (doReloadAfterClose) {
      const {
        checkUpdateLink
      } = pluginUpdate;

      if (checkUpdateLink) {
        window.location.href = checkUpdateLink;
      } else {
        window.location.reload();
      }
    } else {
      pluginUpdateStore.hideModal();
    }
  }, [doReloadAfterClose, pluginUpdateStore, pluginUpdate]);
  const handleChange = useCallback(() => setDoReloadAfterClose(true), [setDoReloadAfterClose]);
  const error = pluginUpdateFetchErrors.get(modalPlugin);
  useEffect(() => {
    document.body.classList[modalPlugin ? "add" : "remove"]("rpm-wpc-antd-modal-open");
  }, [modalPlugin]);
  return modalPlugin ? /*#__PURE__*/React.createElement(Modal, {
    visible: true,
    okButtonProps: {
      form: "license-form-".concat(pluginUpdate === null || pluginUpdate === void 0 ? void 0 : pluginUpdate.slug),
      htmlType: "submit",
      style: {
        display: (pluginUpdate === null || pluginUpdate === void 0 ? void 0 : pluginUpdate.unlicensedEntries.length) === 0 || error ? "none" : undefined
      }
    },
    cancelButtonProps: {
      style: {
        display: "none"
      }
    },
    onCancel: handleCancel,
    okText: __("Save"),
    title: pluginUpdate ? /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: "normal"
      }
    }, /*#__PURE__*/React.createElement("strong", null, pluginUpdate.name, ":"), " ", __("License settings")) : "",
    width: 800
  }, error ? /*#__PURE__*/React.createElement(PluginUpdateErrorNotice, {
    slug: modalPlugin
  }) : busy || !pluginUpdate ? /*#__PURE__*/React.createElement(Spin, {
    spinning: true
  }) : /*#__PURE__*/React.createElement("div", null, showHeadline && /*#__PURE__*/React.createElement(Divider, {
    type: "horizontal",
    orientation: "left",
    style: {
      marginTop: 0
    }
  }, __("Not yet licensed")), /*#__PURE__*/React.createElement(PluginUpdateForm, {
    onSave: handleChange,
    pluginUpdate: pluginUpdate
  }), showHeadline && /*#__PURE__*/React.createElement(Divider, {
    type: "horizontal",
    orientation: "left"
  }, __("Already licensed")), pluginUpdate.licensedEntries.length > 0 && /*#__PURE__*/React.createElement(PluginUpdateLicenseList, {
    onDeactivate: handleChange,
    pluginUpdate: pluginUpdate
  }))) : null;
});
export { PluginUpdateModal };